<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
          <strong>Adhoc Vehicle Details</strong> 
          </div>
          <b-row>
            <b-col md="12" >
              <div>
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item">
                    <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Details Pending Against Adhoc Vehicles</a>
                  </li>

                  <li class="nav-item">
                    <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Adhoc Vehicles</a>
                  </li>
                </ul>
              </div>
            </b-col>

            <b-col md="12" >
          
              <div class="tab-panel" v-if="isActiveTab(0)">
                <Adhoc_pendingvehicle style="width:70%;"></Adhoc_pendingvehicle>
              </div>

              <div class="tab-panel" v-if="isActiveTab(1)">
              <Adhoc_regularvehicle style="width:70%;"></Adhoc_regularvehicle>
              </div>
            </b-col>
        </b-row> 
        </b-card>
      </b-col>
    </b-row> 
  </div>   
  
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Adhoc_pendingvehicle from './Adhoc_pendingvehicle.vue'
import Adhoc_regularvehicle from './Adhoc_regularvehicle.vue'

export default {
  data: function() {
    return {
      activeTab: 0,
      Adhoc_pendingvehicle,
      Adhoc_regularvehicle,
    };
  },
  components: {
    Adhoc_pendingvehicle,
    Adhoc_regularvehicle,
  },
  created: function() {
    this.isActiveTab(0);
  },
  beforeUpdate(){
    // console.log("beforeUpdateall----->",this.$route)
  },
  methods: {
  	isActiveTab(id)
    {
       return this.activeTab === id
    }
  }
};
</script>
